import { useEffect, useRef, useState } from "react";
import {
  CONSULTATION_ICONS,
  EDIT_ICON,
} from "../../cufront-assets/icons/Icons";
import { MEDICINE_FIELDS, medicineFormAtom } from "../constants/_constant";
import "../css/ConsultationMedicineTable.css";
import OtherIcons from "./OtherIcons";
// import CuDropdown from "../../common_component/component/CuDropdown";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { GrFormAdd } from "react-icons/gr";
// import CuModal from "../../common_component/component/CuModal";
import CuButton from "../../all-patient/components/CuButton";
// import CuInput from "../../all-patient/components/CuInput";
// import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
// import CuDropdown from "../../common_component/component/CuDropdown";
import { Modal } from "semantic-ui-react";
import { IoClose } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import CuSpinner from "../../common_component/component/CuSpinner";

const DURATIONOPTIONS = ["DAY", "WEEK", "MONTH", "YEAR"];

const ConsultationMedicineTable = ({ medicineData, setMedicineData }) => {
  const [formData, setFormData] = useAtom(medicineFormAtom);
  const [searchInput, setSearchInput] = useState({
    medicineName: "",
    genericName: "",
    dosage: "",
    unit: "",
    when: "",
    frequency: "",
    duration: "",
    notes: "",
    medicineType: "",
  });
  const [options, setOptions] = useState({
    medicineName: [],
    genericName: [],
    dosage: [],
    unit: [],
    when: [],
    frequency: [],
    duration: [],
    notes: [],
    medicineType: [],
  });
  const [selectedOption, setSelectedOption] = useState(0);
  const containerRef = useRef(null);
  // const inputRefs = useRef([]);
  const optionRef = useRef([]);
  const addBtnRef = useRef(null);
  // const tableInputRef = useRef(null)
  const [clinic] = useAtom(clinicAtom);
  const [isDescription, setIsDescription] = useState(false);
  const [descriptionData, setDescriptionData] = useState({
    genericName: {
      name: "",
    },
    medicineType: {
      name: "",
      label: "",
    },
    index: "",
  });
  const [openedInput, setOpenedInput] = useState({ fieldName: "", index: "" });
  const [selectedMedId, setSelectedMedId] = useState(null);

  const createBlankRow = () => {
    const blankRow = {
      id: null,
      medicineName: "",
      recentlyUsedCount: 0,
      genericName: {
        name: "",
      },
      medicineType: {
        name: "",
        label: "",
      },
      dosage: {
        label: "",
        name: "",
      },
      unit: {
        label: "",
        name: "",
      },
      when: {
        label: "",
        name: "",
      },
      frequency: {
        label: "",
        name: "",
      },
      duration: "",
      notes: {
        name: "",
      },
      timing: {
        name: "",
      },
      category: {
        name: "",
      },
    };
    return blankRow;
  };

  //("Medicine_data", medicineData);

  const handleAddMedicine = () => {
    // if (formData?.id && formData?.medicineName?.length > 0) {
    //   setMedicineData((prev) => [...prev, formData]);
    //   handleClearInput();
    // } else {
    //   toast.error("Please add medicine first");
    // }

    setMedicineData((prev) => [...prev, createBlankRow()]);
  };

  const handleDeleteMedicine = (idx) => {
    if (medicineData?.length > 1) {
      setMedicineData((prev) => {
        const temp = [...prev];
        temp.splice(idx, 1);
        return temp;
      });
    } else {
      setMedicineData([createBlankRow()]);
    }
  };

  const clearSearchAndSuggestion = () => {
    setSearchInput({
      medicineName: "",
      genericName: "",
      dosage: "",
      unit: "",
      when: "",
      frequency: "",
      duration: "",
      notes: "",
      medicineType: "",
    });
    setOptions({
      medicineName: [],
      genericName: [],
      dosage: [],
      unit: [],
      when: [],
      frequency: [],
      duration: [],
      notes: [],
      medicineType: [],
    });
  };

  const handleClearInput = () => {
    setFormData({
      id: null,
      medicineName: "",
      recentlyUsedCount: 0,
      genericName: {
        name: "",
      },
      medicineType: {
        name: "",
        label: "",
      },
      dosage: {
        label: "",
        name: "",
      },
      unit: {
        label: "",
        name: "",
      },
      when: {
        label: "",
        name: "",
      },
      frequency: {
        label: "",
        name: "",
      },
      duration: "",
      notes: {
        name: "",
      },
      timing: {
        name: "",
      },
      category: {
        name: "",
      },
    });
    clearSearchAndSuggestion();
  };

  const { data: medicines } = useItemsFilter(
    `master_data/name_medicine/`,
    `?medicine_name=${searchInput?.medicineName}`,
    searchInput?.medicineName?.length > 0 ? true : false
  );

  const { data: genericName } = useItemsFilter(
    ApiEndPoint.QP_CM_GENERIC_NAME,
    `?action=getGenericName&frontend=True&clinic_id=${clinic?.id}&name__startswith=${searchInput?.genericName}`,
    searchInput?.genericName?.length > 0 ? true : false
  );
  const { data: dosage } = useItemsFilter(
    `master_data/dosage/`,
    `?name=${searchInput?.dosage}`,
    searchInput?.dosage?.length > 0 ? true : false
  );
  const { data: unit } = useItemsFilter(
    `master_data/unit/`,
    `?name=${searchInput?.unit}`,
    searchInput?.unit?.length > 0 ? true : false
  );
  const { data: when } = useItemsFilter(
    `master_data/when/`,
    `?name=${searchInput?.when}`,
    searchInput?.when?.length > 0 ? true : false
  );
  const { data: frequency } = useItemsFilter(
    `master_data/frequency/`,
    `?name=${searchInput?.frequency}`,
    searchInput?.frequency?.length > 0 ? true : false
  );
  const { data: notes } = useItemsFilter(
    `master_data/notes/`,
    `?name=${searchInput?.notes}`,
    searchInput?.notes?.length > 0 ? true : false
  );

  const { data: selectedMedData, isLoading: selectedMedLoading } =
    useItemsFilter(
      ApiEndPoint.QP_CM_MEDICINE_DATA,
      `?action=getMedicineData&id=${selectedMedId}&medicine_data=True`,
      selectedMedId && clinic?.id ? true : false
    );

  useEffect(() => {
    if (selectedMedData && selectedMedId) {
      handleSelectOptionList(
        selectedMedData,
        "medicineName",
        openedInput.index,
        "selectedMed"
      );
      setSelectedMedId(null);
    }
  }, [selectedMedData, selectedMedId]);

  useEffect(() => {
    if (medicines) {
      // const options = convertIntoOptions("medicine_name", medicines);
      setOptions((prev) => ({ ...prev, medicineName: medicines }));
    }
    if (genericName) {
      // const options = convertIntoOptions("name", genericName);
      setOptions((prev) => ({ ...prev, genericName: genericName }));
    }
    if (dosage) {
      // const options = convertIntoOptions("name", dosage);
      setOptions((prev) => ({ ...prev, dosage: dosage }));
    }
    if (unit) {
      // const options = convertIntoOptions("label", unit);
      setOptions((prev) => ({ ...prev, unit: unit }));
    }
    if (when) {
      // const options = convertIntoOptions("label", when);
      setOptions((prev) => ({ ...prev, when: when }));
    }
    if (frequency) {
      // const options = convertIntoOptions("label", frequency);
      setOptions((prev) => ({ ...prev, frequency: frequency }));
    }
    if (notes) {
      // const options = convertIntoOptions("name", notes);
      setOptions((prev) => ({ ...prev, notes: notes }));
    }
  }, [
    genericName,
    dosage,
    unit,
    when,
    frequency,
    notes,
    medicines,
    // medicine_type,
    // medicine_type,
    // category,
  ]);

  const fillSearchInput = (val, label) => {
    setSearchInput({
      medicineName: "",
      genericName: "",
      dosage: "",
      unit: "",
      when: "",
      frequency: "",
      duration: "",
      notes: "",
      medicineType: "",
      [label]: val,
    });
  };

  const handleFillMedicineList = (val, label, midx) => {
    if (label !== "medicineName" && !medicineData[midx]?.id) {
      toast.error("Please add medicine");
      return;
    }
    fillSearchInput(val, label);
    if (label === "genericName" || label === "notes") {
      setMedicineData((prev) => {
        const temp = [...prev];
        temp[midx][label] = { name: val };
        return temp;
      });
      return;
    }

    if (label === "duration" && !isNaN(parseInt(val))) {
      setOptions((prev) => ({
        ...prev,
        duration: DURATIONOPTIONS.map((tym) => ({
          name: `${parseInt(val)}-${tym}`,
        })),
      }));
    }

    if (label === "medicineName" || label === "duration") {
      setMedicineData((prev) => {
        const temp = [...prev];
        temp[midx][label] = val;
        if (label === "medicineName") {
          temp[midx].id = `new_${midx}`;
        }
        return temp;
      });
      return;
    }

    let extraDash = "";
    if (label === "dosage") {
      if (
        medicineData[midx][label]?.name?.length < val?.length ||
        medicineData[midx][label]?.name?.length === ""
      ) {
        if (val.length <= 3) {
          extraDash = `-`;
        }
      }
    }

    setMedicineData((prev) => {
      const temp = [...prev];
      temp[midx][label] = { label: val + extraDash, name: val + extraDash };
      return temp;
    });
  };
  const isAlreadyExist = (medId) => {
    const existingIdx = medicineData?.findIndex((med) => med?.id === medId);
    if (existingIdx === -1) {
      return false;
    } else {
      return true;
    }
  };

  const handleSelectOptionList = (
    val,
    label,
    index,
    type = "suggestionMed"
  ) => {
    if (label === "medicineName") {
      if (type === "suggestionMed" && isAlreadyExist(val?.id)) {
        toast.error(`${val?.medicine_name} is already exist`);
        return;
      }
      setMedicineData((prev) => {
        const newMed = {
          id: val?.id,
          medicineName: val?.medicine_name,
          recentlyUsedCount: 0,
          genericName: {
            id: val?.generic_name?.id,
            name: val?.generic_name?.name,
          },
          medicineType: {
            id: val?.medicine_type?.id,
            name: val?.medicine_type?.name,
            label: val?.medicine_type?.label,
          },
          dosage: {
            id: val?.dosage?.id,
            label: val?.dosage?.label,
            name: `${
              val?.dosage?.name === "nan" || !val?.dosage?.name
                ? ""
                : val?.dosage?.name
            }`,
          },
          unit: {
            id: val?.unit?.id,
            label: val?.unit?.label,
            name: `${
              val?.unit?.name === "nan" || !val?.unit?.name
                ? ""
                : val?.unit?.name
            }`,
          },
          when: {
            id: val?.when?.id,
            label: val?.when?.label,
            name: `${
              val?.when?.name === "nan" || !val?.when?.name
                ? ""
                : val?.when?.name
            }`,
          },
          frequency: {
            id: val?.frequency?.id,
            label: val?.frequency?.label,
            name: `${
              val?.frequency?.name === "nan" || !val?.frequency?.name
                ? ""
                : val?.frequency?.name
            }`,
          },
          duration: `${val?.duration === "nan" ? "" : val?.duration}`,
          notes: {
            id: val?.notes?.id,
            name: `${
              val?.notes?.name === "nan" || !val?.notes?.name
                ? ""
                : val?.notes?.name
            }`,
          },
          timing: {
            name: "",
          },
          category: {
            name: "",
          },
        };
        const temp = [...prev];
        temp[index] = newMed;
        return temp;
      });
      if (type === "suggestionMed") {
        setSelectedMedId(val?.id);
      }
    } else if (label === "duration") {
      setMedicineData((prev) => {
        const temp = [...prev];
        temp[index].duration = val?.name;
        return temp;
      });
      // } else if (label === "genericName" || label === "notes") {
      //   setMedicineData((prev) => {
      //   const temp = [...prev];
      //   temp[index][label] = { name: val?.name, id: val?.id }
      //   });
    } else {
      setMedicineData((prev) => {
        const temp = [...prev];
        temp[index][label] = { name: val?.name, id: val?.id };
        return temp;
      });
    }

    clearSearchAndSuggestion();
  };

  const handleKeyEvent = (e, field, inputIdx, tableIdx, nextCol) => {
    if (
      e.key === "ArrowDown" &&
      selectedOption < options[field.key]?.length - 1
    ) {
      e.preventDefault();
      setSelectedOption((prev) => prev + 1);
      const selectedOptionElement = optionRef.current[selectedOption + 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.bottom > containerRect.bottom) {
          containerRef.current.scrollTop +=
            optionRect.bottom - containerRect.bottom;
        }
      }
    } else if (e.key === "ArrowUp" && selectedOption > 0) {
      e.preventDefault();
      setSelectedOption((prev) => prev - 1);
      const selectedOptionElement = optionRef.current[selectedOption - 1];
      if (selectedOptionElement) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const optionRect = selectedOptionElement.getBoundingClientRect();
        if (optionRect.top < containerRect.top) {
          containerRef.current.scrollTop -= containerRect.top - optionRect.top;
        }
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (
        searchInput[field.key]?.length > 0 &&
        options[field.key]?.length > 0
      ) {
        optionRef.current[selectedOption].click();
        if (
          nextCol === "dosage" &&
          isAlreadyExist(options[field.key][selectedOption]?.id)
        ) {
          // setSelectedOption(0);
          return;
        }
      }
      if (inputIdx === "description") {
        setSelectedOption(0);
        return;
      }
      if (inputIdx === "list" && tableIdx <= medicineData?.length - 1) {
        if (nextCol !== "medicinename") {
          setOpenedInput({ fieldName: nextCol, index: tableIdx });
        } else {
          setOpenedInput({ fieldName: "medicinename", index: tableIdx + 1 });
          if (tableIdx === medicineData?.length - 1) {
            addBtnRef.current.click();
          }
        }
      }

      setSelectedOption(0);
    }
  };

  const handleAddDescription = (type = "form", index) => {
    if (type === "form" && formData?.id && formData?.medicineName?.length > 0) {
      setIsDescription(true);
    } else if (
      type === "list" &&
      medicineData[index]?.id &&
      medicineData[index]?.medicineName?.length > 0
    ) {
      setDescriptionData({
        genericName: { ...medicineData[index]?.genericName },
        medicineType: { ...medicineData[index]?.medicineType },
        index: index,
      });
      setIsDescription(true);
    } else {
      toast.error("Please add medicine");
    }
  };

  const handleDescriptionChange = (val, label) => {
    fillSearchInput(val, label);
    if (label === "genericName") {
      setDescriptionData((prev) => ({ ...prev, [label]: { name: val } }));
      return;
    }
    setDescriptionData((prev) => ({
      ...prev,
      [label]: { label: val, name: val },
    }));
  };

  const handleSelectDescriptionOption = (val, label) => {
    if (label === "genericName") {
      setDescriptionData((prev) => ({
        ...prev,
        [label]: { name: val?.name, id: val?.id },
      }));
    } else {
      setDescriptionData((prev) => ({
        ...prev,
        [label]: { label: val?.name, name: val?.name, id: val?.id },
      }));
    }
    clearSearchAndSuggestion();
  };

  const closeDescription = () => {
    setDescriptionData({
      genericName: {
        name: "",
      },
      medicineType: {
        name: "",
        label: "",
      },
      index: "",
    });
    setIsDescription(false);
  };

  const handleSaveDescription = () => {
    setMedicineData((prev) => {
      const temp = [...prev];
      temp[descriptionData?.index].genericName = {
        ...descriptionData?.genericName,
      };
      temp[descriptionData?.index].medicineType = {
        ...descriptionData?.medicineType,
      };
      return temp;
    });
    clearSearchAndSuggestion();
    closeDescription();
  };

  const handleOpenInput = (name, idx) => {
    setOpenedInput({ fieldName: name, index: idx });
  };

  const openedInputHandler = (field, medIdx, nextCol) => {
    return (
      <div style={{ position: "relative" }}>
        <input
          type="text"
          className="cu-consultation-medicinedetails-input"
          placeholder={field.label}
          value={
            field?.key === "medicineName" || field?.key === "duration"
              ? medicineData[medIdx][field.key]
              : medicineData[medIdx][field.key]?.name
          }
          onChange={(e) =>
            handleFillMedicineList(
              e.target.value?.toUpperCase(),
              field?.key,
              medIdx
            )
          }
          autoFocus
          onKeyDown={(e) => handleKeyEvent(e, field, "list", medIdx, nextCol)}
        />
        {searchInput[field?.key]?.length > 0 &&
          options[field?.key]?.length > 0 &&
          openedInput?.fieldName?.length > 0 && (
            <div
              className="cu-consultation-medicine-suggestion-list"
              ref={containerRef}
            >
              {options[field.key]?.map((option, opidx) => {
                return (
                  <div
                    className={`cu-consultation-medicine-suggestion-list-item ${
                      selectedOption === opidx
                        ? "cu-consultation-medicine-suggestion-list-item-active"
                        : ""
                    }`}
                    key={option?.id}
                    onClick={() =>
                      handleSelectOptionList(option, field.key, medIdx)
                    }
                    ref={(el) => (optionRef.current[opidx] = el)}
                  >
                    {field.key === "medicineName"
                      ? option?.medicine_name
                      : option?.name}
                  </div>
                );
              })}
            </div>
          )}
      </div>
    );
  };

  return (
    <div className="cu-consultation-medicinedetails-container">
      <div className="cu-consultation-medicinedetails-label-cont">
        <label className="cu-consultation-customfield-label">
          Medicine Details
        </label>
        <OtherIcons
          type={"medicine"}
          setData={setMedicineData}
          data={medicineData}
          setDescriptionData={setDescriptionData}
          descriptionData={descriptionData}
        />
      </div>
      <div className="w-full pr-3">
        <table className="w-full cu-consultation-medicine-table">
          <thead>
            <th></th>
            {MEDICINE_FIELDS?.map((medTh) => (
              <th key={medTh?.id}>{medTh?.label}</th>
            ))}
            <th></th>
          </thead>
          <tbody>
            {medicineData?.map((data, idx) => {
              return (
                <tr key={idx}>
                  <td className="cu-consultation-medicine-list-item cu-consultation-idx-col">
                    <div className="cu-consultation-medicine-text">
                      {idx + 1}
                    </div>
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-medicine-col relative">
                    {(openedInput?.fieldName !== "medicinename" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("medicinename", idx)}
                      >
                        {data?.medicineName || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "medicinename" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Medicine name",
                          width: "230px",
                          key: "medicineName",
                        },
                        idx,
                        "dosage"
                      )}

                    {(openedInput?.fieldName !== "medicinename" ||
                      openedInput?.index !== idx) && (
                      <div className="flex items-center justify-center">
                        <div className="cu-consultation-medicine-sec-text">
                          {data?.genericName?.name}
                        </div>
                        {data?.medicineName && (
                          <div className="absolute right-[6px]">
                            <img
                              src={EDIT_ICON}
                              alt="edit"
                              width={"13px"}
                              height={"13px"}
                              onClick={() => handleAddDescription("list", idx)}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-dosage-col">
                    {(openedInput?.fieldName !== "dosage" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("dosage", idx)}
                      >
                        {data?.dosage?.name || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "dosage" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Dosage",
                          width: "90px",
                          key: "dosage",
                        },
                        idx,
                        "unit"
                      )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-unit-col">
                    {(openedInput?.fieldName !== "unit" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("unit", idx)}
                      >
                        {data?.unit?.name || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "unit" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Unit",
                          width: "90px",
                          key: "unit",
                        },
                        idx,
                        "when"
                      )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-when-col">
                    {(openedInput?.fieldName !== "when" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("when", idx)}
                      >
                        {data?.when?.name || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "when" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "When",
                          width: "90px",
                          key: "when",
                        },
                        idx,
                        "frequency"
                      )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-frequency-col">
                    {(openedInput?.fieldName !== "frequency" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("frequency", idx)}
                      >
                        {data?.frequency?.name || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "frequency" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Frequency",
                          width: "90px",
                          key: "frequency",
                        },
                        idx,
                        "duration"
                      )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-duration-col">
                    {(openedInput?.fieldName !== "duration" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("duration", idx)}
                      >
                        {data?.duration || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "duration" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Duration",
                          width: "90px",
                          key: "duration",
                        },
                        idx,
                        "notes"
                      )}
                  </td>
                  <td className="cu-consultation-medicine-list-item cu-consultation-notes-col">
                    {(openedInput?.fieldName !== "notes" ||
                      openedInput?.index !== idx) && (
                      <div
                        className="cu-consultation-medicine-text"
                        onClick={() => handleOpenInput("notes", idx)}
                      >
                        {data?.notes?.name || "-"}
                      </div>
                    )}
                    {openedInput?.fieldName === "notes" &&
                      openedInput?.index === idx &&
                      openedInputHandler(
                        {
                          label: "Notes",
                          width: "130px",
                          key: "notes",
                        },
                        idx,
                        "medicinename"
                      )}
                  </td>
                  <td className="cu-consultation-del-col cursor-pointer">
                    <div className="flex justify-center gap-3">
                      {openedInput?.index === idx && selectedMedLoading ? (
                        <CuSpinner />
                      ) : (
                        <>
                          <IoClose onClick={() => handleDeleteMedicine(idx)} />
                          {medicineData?.length - 1 === idx && (
                            <span onClick={handleAddMedicine} ref={addBtnRef}>
                              <IoMdAdd />
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isDescription && (
        <Modal
          onClose={closeDescription}
          open={isDescription}
          size="small"
          closeIcon
        >
          <Modal.Header>Edit Description</Modal.Header>
          <Modal.Content>
            <div className="p-3">
              <div className="w-full mt-3">
                <div className="relative">
                  <label className="cu-medicinetable-label">Generic Name</label>
                  <input
                    type="text"
                    className="cu-consultation-medicinedetails-input"
                    placeholder={"Generic Name"}
                    value={descriptionData?.genericName?.name}
                    onChange={(e) =>
                      handleDescriptionChange(
                        e.target.value.toUpperCase(),
                        "genericName"
                      )
                    }
                    // ref={(el) => (inputRefs.current[inputIdx] = el)}
                    onKeyDown={(e) =>
                      handleKeyEvent(e, { key: "genericName" }, "description")
                    }
                  />
                  {searchInput["genericName"]?.length > 0 &&
                    options["genericName"]?.length > 0 && (
                      <div
                        className="cu-consultation-medicine-suggestion-list"
                        ref={containerRef}
                      >
                        {options["genericName"]?.map((option, opidx) => {
                          return (
                            <div
                              className={`cu-consultation-medicine-suggestion-list-item ${
                                selectedOption === opidx
                                  ? "cu-consultation-medicine-suggestion-list-item-active"
                                  : ""
                              }`}
                              key={option?.id}
                              onClick={() =>
                                handleSelectDescriptionOption(
                                  option,
                                  "genericName"
                                )
                              }
                              ref={(el) => (optionRef.current[opidx] = el)}
                            >
                              {option?.name}
                            </div>
                          );
                        })}
                      </div>
                    )}
                </div>
              </div>
              <div className="mt-4 w-full flex justify-end items-center">
                <CuButton
                  className="w-32 h-11 rounded-lg helvetica bg-[#EBF8EC]"
                  onClick={handleSaveDescription}
                >
                  Save
                </CuButton>
              </div>
            </div>
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};

export default ConsultationMedicineTable;
